/** 5MB common chunk size  */
export const DEFAULT_CHUNK_SIZE = 5242880

/** 15MB maximum file size for agent uploads (backend allows some headroom) */
export const MAX_AGENT_FILE_SIZE = 15728640

export const ROWS_PER_PAGE = 5

export const ROWS_PER_PAGE_OPTIONS = [5, 10, 15, 20, 25, 50]

export const TIMEOUT_MS = 1000

export const SHORT_TIMEOUT_MS = 500

export const DOWNLOAD_IFRAME_CLEANUP_DELAY_MS = 60000

export const TOOLTIP_DELAY = 500

// Tablets / phones report no hover and a coarse pointer regardless of their viewport width,
// so this is the only reliable way to tell a tablet from a laptop of the same size.
export const TOUCH_DEVICE_QUERY = '(hover: none) and (pointer: coarse)'

// Same check, ready to be used as a key inside makeStyles.
export const TOUCH_DEVICE_MEDIA_QUERY = `@media ${TOUCH_DEVICE_QUERY}`

export const MAXIMUM_FRACTION_DIGITS = 14

export const SNAPGRID = 10

export const HANDLE_DATA_WIZARD = '_handle_data_wizard_'

export const FILE_FOLDER_VALIDATION_REGEX = /^[a-z0-9_-\sA-Z+%&*]+$/g

export const APPS_VERSIONS_SCENARIOS_VALIDATION_REGEX = /^[a-z0-9_-\sA-Z()+%&*]+$/g

export const CODE_NODE_PROPERTIES_TO_GET = [
  { name: 'identifier' },
  { name: 'title' },
  { name: 'nodeClass' },
  { name: 'definition' },
  { name: 'isCalc' },
  { name: 'lastEvaluationConsole' },
  { name: 'lastEvaluationError' },
  { name: 'units' },
  { name: 'prefixIdentifier' },
  { name: 'hierarchy' },
  { name: 'resultType' }
]
export const DATE_FORMAT = 'yyyy-MM-dd HH:mm:ss'
export const TIMEZONE = Intl.DateTimeFormat().resolvedOptions().timeZone

/** Public legal documents hosted in the Pyplan documentation site */
export const TERMS_OF_SERVICE_URL = 'https://docs.pyplan.com/legal/terms-of-service'
export const PRIVACY_POLICY_URL = 'https://docs.pyplan.com/legal/privacy-policy'
